import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { Iconify } from '@app/components';
import useResponsive from '@app/hooks/use-responsive';
import { Strings } from '@app/constants';
import { SvgColor } from '@app/components/svg-color';
import { ProfileSettings } from '@app/modules/manage-profile';
import { PATH_DASHBOARD } from '@app/routes/paths';
import Main from './Main';
import NavVertical from './nav/NavVertical';
import navConfig from './nav/config-navigation';

// ----------------------------------------------------------------------
interface NavItem {
  title: string;
  path: string;
  icon?: JSX.Element;
  children?: NavItem[];
}
export default function DashboardLayout() {
  const navigation = useNavigate();
  const { pathname } = useLocation();
  const isMobile = useResponsive('down', 'sm');

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [value, setValue] = useState(navConfig[0]?.path);
  const [openDrawer, setOpenDrawer] = useState<any>(false);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    navigation(newValue);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const renderNavVertical = <NavVertical openNav={isDrawerOpen} onCloseNav={toggleDrawer} />;

  const findItemByPath = (navItems: NavItem[], path: string): NavItem | null => {
    for (const navConfig of navItems) {
      if (navConfig.path === path) {
        return navConfig;
      }
      if (navConfig.children) {
        const childItem = findItemByPath(navConfig.children, path);
        if (childItem) {
          return childItem;
        }
      }
    }
    return null;
  };

  const currentItem = findItemByPath(navConfig, pathname);

  useEffect(() => {
    setDrawerOpen(false);
  }, [setDrawerOpen, pathname]);

  return (
    <>
      <Stack>
        <Box sx={{ flexGrow: 1, bgcolor: 'white' }}>
          <AppBar color="transparent" position="static">
            <Toolbar>
              {/* <MenuIconStyled>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={toggleDrawer}
                  sx={{ m: 1 }}
                >
                  <Iconify icon={'oi:menu'} />
                </IconButton>
              </MenuIconStyled> */}
              <Typography
                onClick={() => navigation(PATH_DASHBOARD.onBoarding)}
                variant="h4"
                color="primary"
                component="div"
                sx={{ flexGrow: 1, cursor: 'pointer' }}
                mx={2}
              >
                {Strings.header.chef}
                <SvgColor src={`/assets/icons/ic_red_hat.svg`} color="black" fontWeight={'bold'} />
              </Typography>

              <div>
                <IconButton onClick={() => setOpenDrawer(true)} color="primary">
                  <Iconify height={30} width={30} icon={'solar:user-bold'} />
                </IconButton>
              </div>
            </Toolbar>
            <Tabs
              sx={{ px: 5, mb: 1 }}
              value={pathname}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              TabIndicatorProps={{ sx: { height: 4, borderRadius: '50px' } }}
              aria-label="secondary tabs example"
            >
              {navConfig?.map((screen) => <Tab value={screen.path} label={screen?.title} />)}
            </Tabs>
          </AppBar>
          <ProfileSettings openNav={openDrawer} onCloseNav={() => setOpenDrawer(false)} />
        </Box>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          height: isMobile ? '90vh' : 'auto',
        }}
      >
        {renderNavVertical}

        <Main>
          <Stack
            sx={{
              p: 2,
              mb: '20vh',
            }}
          >
            <Helmet>
              <title>{Strings.header.chef}</title>
            </Helmet>
            <Outlet />
          </Stack>
        </Main>
      </Box>
    </>
  );
}
